export function numberWithCommas(x) {
	console.log('This is the x', x);
	if (x !== undefined) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}
}
